module.exports = __webpack_public_path__ + "img/filter.6a4f3e60.svg";